const exportsReducer = (state=[], action)=>{
  switch (action.type) {
    case 'FINISH_EXPORT':
      return state.filter(t => t.id !== action.payload)
    case 'EXPORT_STORIES':
      let newExport=Object.assign({}, action.payload, {id:action.id || (new Date()).getTime()})
      return [
        ...state,
        newExport
      ]
   default:
     return state
 }
}
export default exportsReducer;



// WEBPACK FOOTER //
// ./src/utils/reducers/exports.js